import { render, staticRenderFns } from "./DiscountTable.vue?vue&type=template&id=deb8cb98&scoped=true&"
import script from "./DiscountTable.vue?vue&type=script&lang=js&"
export * from "./DiscountTable.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTable.vue?vue&type=style&index=0&id=deb8cb98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb8cb98",
  null
  
)

export default component.exports